<script lang="ts">
	import { colorThemes } from '../theme/colors'
	import '@repo/ui/form.css'
	import '@repo/ui/theme.css'
	import { colorTheme } from '@store/theme'

	interface Props {
		children?: import('svelte').Snippet
	}

	let { children }: Props = $props()

	const variants = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950]

	function getThemeVariables(theme: string) {
		if (theme && colorThemes.includes(theme)) {
			return variants
				.map((variant) => `--color-primary-${variant}: var(--color-${theme}-${variant})`)
				.join(';')
		}
	}
</script>

<div
	id="root"
	style={getThemeVariables($colorTheme)}
	class="font-body text-body contents text-base dark:bg-gray-900 dark:text-gray-100"
>
	{@render children?.()}
</div>
